<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div :class="{ card: !embedded }">
        <h4 v-if="!embedded">Follow-up Steps</h4>
        <p v-if="!embedded">Each step is one email, sent the given number of days after the quote is booked.</p>

        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Step"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
        </div>

        <FollowupStepsTable
          :key="'FollowupStepsTable' + tableKey"
          :steps="steps"
          :loading="requesting"
          @edit-step="editStep"
          @delete-step="askDelete"
        />

        <FollowupStepForm
          :key="'FollowupStepForm' + formKey"
          :stepToEdit="step"
          :stepForm="stepForm"
          :serverErrors="serverErrors"
          @close="hideForm"
          @save="saveStep"
        />

        <Dialog :visible.sync="deleteDialog" header="Delete step" :modal="true" :style="{ width: '420px' }">
          <p v-if="toDelete">Delete step {{ toDelete.stepNo }}? To pause it instead, edit it and mark it Inactive.</p>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteDialog = false" />
            <Button label="Yes, delete" icon="pi pi-check" class="p-button-text p-button-danger" @click="confirmDelete" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import FollowupService, { errorMessage, fieldErrors } from '@/service/FollowupService'
import FollowupStepsTable from './followupStepsTable'
import FollowupStepForm from './followupStepForm'

export default {
  // P6: shown inside a Follow-up Settings tab, which gives the title and explanation
  props: {
    embedded: { type: Boolean, default: false },
    // batch 3: a quote type's own steps; null = the default steps
    projectTypeId: { type: Number, default: null }
  },
  components: { FollowupStepsTable, FollowupStepForm },
  data: () => ({
    followupService: new FollowupService(),
    steps: [],
    step: {},
    stepForm: false,
    serverErrors: {},
    tableKey: 0,
    formKey: 0,
    requesting: false,
    deleteDialog: false,
    toDelete: null
  }),
  created() {
    this.getSteps()
  },
  methods: {
    getSteps() {
      this.requesting = true
      return this.followupService.getSteps(this.projectTypeId)
        .then(data => {
          this.steps = data || []
          this.tableKey++
        })
        .catch(err => {
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: errorMessage(err, 'Some data was not loaded from "followupSteps"')
          })
        })
        .finally(() => { this.requesting = false })
    },
    openNew() {
      this.step = {}
      this.serverErrors = {}
      this.stepForm = true
      this.formKey++
    },
    editStep(step) {
      this.step = step
      this.serverErrors = {}
      this.stepForm = true
      this.formKey++
    },
    hideForm() {
      this.step = {}
      this.stepForm = false
    },
    saveStep(step) {
      var call = step.id ? this.followupService.editStep(step)
        : this.followupService.saveStep(this.projectTypeId === null ? step : { ...step, projectTypeId: this.projectTypeId })
      return call
        .then(() => {
          this.$toast.add({ severity: 'success', summary: 'Step saved', detail: 'The follow-up step was saved.', life: 5000 })
          this.stepForm = false
          this.getSteps()
          this.$emit('changed')
        })
        .catch(err => {
          this.serverErrors = fieldErrors(err)
          this.$toast.add({ severity: 'error', summary: 'Not saved', detail: errorMessage(err, 'The step could not be saved.'), life: 5000 })
        })
    },
    askDelete(step) {
      this.toDelete = step
      this.deleteDialog = true
    },
    confirmDelete() {
      var step = this.toDelete
      this.deleteDialog = false
      return this.followupService.deleteStep(step.id)
        .then(() => {
          this.$toast.add({ severity: 'success', summary: 'Step deleted', detail: 'Step ' + step.stepNo + ' was deleted.', life: 5000 })
          this.getSteps()
          this.$emit('changed')
        })
        .catch(err => {
          this.$toast.add({ severity: 'error', summary: 'Not deleted', detail: errorMessage(err, 'The step could not be deleted.'), life: 5000 })
        })
    }
  }
}
</script>

<style></style>
